// Submission Board URL
// for SB Creator
export const url_api_v1_sb_search = '/api/v1/projects/:project_uuid/submission_boards/search'; // get SB for a given project
export const url_api_v1_sb_get = '/api/v1/projects/:project_uuid/submission_boards/:sb_id'; // get all SB details, SB,Profiles, Recipients
export const url_api_v1_sb_add = '/api/v1/projects/:project_uuid/submission_boards'; // Add SB
export const url_api_v1_sb_edit_put = '/api/v1/projects/:project_uuid/submission_boards/:sb_id'; // Edit SB
export const url_api_v1_sb_delete = '/api/v1/projects/:project_uuid/submission_boards/:sb_id'; // Delete SB
export const url_api_v1_profile_search = '/api/v1/projects/:project_uuid/users/search/sb';

export const url_api_v1_sb_profile_invite = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/invite`; // add profile to SB
export const url_api_v1_sb_profile_add = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile`; // 
export const url_api_v1_sb_profile_remove = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/:profile_id`; // 
export const url_api_v1_sb_profile_mediareq = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/:profile_id/mediareq`; // 
export const url_api_v1_sb_profiles_reorder = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profiles/reorder`; // reorder profiles

export const url_api_v1_sb_profile_upd = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile`; // update status from recipient for a given profile
export const url_api_v1_sb_review_add =
  '/api/v1/projects/:project_uuid/submission_boards/:sb_id/review'; // send for review
export const url_api_v1_sb_recipients_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/recipients`; // get all recipient for SB
export const url_api_v1_project_recipients =
  '/api/v1/projects/:project_uuid/submission_boards/recipients'; // get all recipient list for a project
export const url_api_v1_project_owners =
  '/api/v1/projects/:project_uuid/submission_boards/owners'; // get all eligible owners list for a project
export const url_api_v1_sb_profile_feedback_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/feedback`; //

// for SB Performer
export const url_api_v1_sb_search_performer = '/api/v1/submission_boards/search'; // get SBs for a performer
export const url_api_v1_sb_get_performer = '/api/v1/projects/:project_uuid/submission_boards/:sb_id/search_perf'; // get all SB details, SB,Profiles, Recipients

// BOTH roles
export const url_api_v1_sb_profiles_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profiles`; // get all shortlisted profile for SB
// Recipient
export const url_api_v1_sb_recipient_action_add = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/action`; //
export const url_api_v1_submission_board_otp_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/otp`; // get status from recipient for a given profile
export const url_api_v1_submission_board_otp_post = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/otp`; // get status from recipient for a given profile

// for media request for a submission board
export const url_api_v1_sb_profile_media_request_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/sb_profiles_media`; // get submission kit and updated media
export const url_api_v1_sb_profile_media_request_create = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/sb_profiles_media`; // get submission kit and updated media
export const url_api_v1_sb_profile_media_request_delete = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/sb_profiles_media/:sb_profiles_media_id`; // get submission kit and updated media

// projects
export const url_api_v1_projects_search_get = '/api/v1/projects'; // get all SKs with filter
export const url_api_v1_project_folders_get = '/api/v1/projects/:project_uuid/folders'; // get all SKs with filter
export const url_api_v1_folder_document_shares_post = '/api/v1/projects/:project_uuid/folder_document_shares';
export const url_api_v1_folder_document_shares_get_otp = '/api/v1/projects/:project_uuid/folder_document_shares/get_otp';
export const url_api_v1_folder_document_shares_validate_otp = '/api/v1/projects/:project_uuid/folder_document_shares/validate_otp';

// Submission Kit URL
export const url_uppy_create_blob = '/uppy/create_blob';
export const url_api_v1_sk_search_get = '/api/v1/submission_kits'; // get all SKs with filter
export const url_api_v1_sk_get = '/api/v1/submission_kits/:sk_id'; // Get SK details with media
export const url_kit_documents = '/api/v1/kit_documents'; // create kit document
export const url_kit_documents_put = '/api/v1/kit_documents/:kit_document_uuid'; // update kit document
export const url_api_v1_sk_doc_add = '/api/v1/submission_kits/kitdocument/create';
export const url_api_v1_sk_doc_remove = '/api/v1/submission_kits/kitdocument/remove';

// Hair & Make-up Kit URL
export const url_api_v1_hmu_kit_get = '/api/v1/hair_make_up_kits'; // get all HMU kit documents
export const url_api_v1_hmu_kit_doc_add = '/api/v1/hair_make_up_kits/kitdocument/create';
export const url_api_v1_hmu_kit_doc_remove = '/api/v1/hair_make_up_kits/kitdocument/remove';
export const url_api_v1_hmu_kit_doc_markfeatured = '/api/v1/hair_make_up_kits/kitdocument/markfeatured';

// Wardrobe Kit URL
export const url_api_v1_wardrobe_kit_get = '/api/v1/wardrobe_kits'; // get all Wardrobe kit documents
export const url_api_v1_wardrobe_kit_doc_add = '/api/v1/wardrobe_kits/kitdocument/create';
export const url_api_v1_wardrobe_kit_doc_remove = '/api/v1/wardrobe_kits/kitdocument/remove';
export const url_api_v1_wardrobe_kit_doc_markfeatured = '/api/v1/wardrobe_kits/kitdocument/markfeatured';

// overview Kit URL
export const url_api_v1_overview_kit_get = '/api/v1/overview_kits'; // get all overview kit documents
export const url_api_v1_overview_kit_doc_add = '/api/v1/overview_kits/kitdocument/create';
export const url_api_v1_overview_kit_doc_remove = '/api/v1/overview_kits/kitdocument/remove';

// Media Kit URL
export const url_api_v1_mk_search = `/api/v1/media_kits`; // get all media kits with filter
export const url_api_v1_mk_update = '/api/v1/media_kits/:mk_id/kit_documents/:kit_id';
export const url_api_v1_mk_delete = '/api/v1/media_kits/:mk_id/kit_documents/:kit_id';

// subscription
export const url_api_v1_user_plan_cancel = '/api/v1/user_plans/cancel';
export const url_api_v1_user_plans = '/api/v1/user_plans';
export const url_api_v1_user_plans_contact_sale_post = '/api/v1/user_plans/contact_sale';
export const url_api_v1_downgrade_reason_post = '/api/v1/user_plans/downgrade_reason';

export const url_api_v1_users_imdb_post = '/api/v1/users/socialkit';
export const url_api_v1_users_search_get = '/api/v1/users/directory';
export const url_api_v1_users_directory_all_get = '/api/v1/users/directory_all';
export const url_api_v1_users_profile_get = '/api/v1/users/:uuid/profile';
export const url_api_v1_profiles_show_get = '/api/v1/profiles/:id';
export const url_api_v1_user_favorites_get = '/api/v1/favorites';
export const url_api_v1_user_favorites_users_get = '/api/v1/favorites/users';
export const url_states_get = '/states';

// skills
export const url_api_v1_user_skills_get = '/api/v1/user_skills';
export const url_api_v1_user_skills_add = '/api/v1/user_skills';
export const url_api_v1_user_skills_search = '/api/v1/user_skills/search';

export const url_api_v1_user_group_get = '/groups/groups_json';
export const url_api_v1_groups_get = '/groups/:group_id';

// old
// for Recipient
export const url_api_v1_sb_recipient_action_get = `/api/v1/projects/:project_uuid/submission_boards/:sb_id/profile/status`; // get status from recipient for a given profile
//Sb shortlist profile
// Sb Profile Notes
export const url_api_v1_sb_profile_notes_add = '/api/v1/projects/:project_uuid/submission_boards/:sb_id/sb_profile_notes';
export const url_api_v1_sb_profile_notes_update = '/api/v1/projects/:project_uuid/submission_boards/:sb_id/sb_profile_notes/:id';
